export const AUTH_PATH = "/auth";

/** Paths which must remain usable without an access token. */
export const PUBLIC_PATHS: ReadonlySet<string> = new Set([
  AUTH_PATH,
  "/payment-result",
  "/vip-payment-result",
]);

export function isPublicPath(path: string): boolean {
  return PUBLIC_PATHS.has(path);
}
